import { hasRole } from '#shared/lib/roles';
import { useUserRoles } from '#shared/composables/useUserRoles';
import { defineNuxtRouteMiddleware, abortNavigation } from 'nuxt/app';

export default defineNuxtRouteMiddleware(() => {
  const roles = useUserRoles();
  if (!hasRole(roles.value ?? [], 'support')) return abortNavigation();
});
